import { Container, Breakpoint } from '@mui/material';

import { ACHelmet } from './ACHelmet';

interface ACHelmetContainerProps {
  title: string;
  maxWidth?: Breakpoint | false;
  children?: React.ReactNode;
}

export const ACHelmetContainer = ({ title, maxWidth, children }: ACHelmetContainerProps) => (
  <>
    <ACHelmet title={title} />
    <Container sx={{ padding: { xs: 0, sm: 3 } }} maxWidth={maxWidth}>
      {children}
    </Container>
  </>
);
